import { render, staticRenderFns } from "./client-board-dynamic-container.vue?vue&type=template&id=3b1d6ba6"
import script from "./client-board-dynamic-container.vue?vue&type=script&lang=js"
export * from "./client-board-dynamic-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports